export default function Home() {
  return (
    <div>
      <h2>首页内容</h2>
      <p>Hello World from Home!</p>
    </div>
  );
}
